// Debug Panel Configuration
export const DEBUG_CONFIG = {
  enabled: true,
  maxNetworkLogs: 100,
  maxEventLogs: 200,
  maxConsoleLogs: 50,
  maxStateHistory: 10,
  defaultExpanded: 'socket' as 'socket' | 'components' | 'logger',
  autoScroll: true,
  persistState: true,
  theme: 'auto' as 'light' | 'dark' | 'auto',
  debounceDelay: 300,
  slowRenderThreshold: 16, // ms
};

export const DEBUG_COLORS = {
  success: '#4caf50',
  warning: '#ff9800',
  error: '#f44336',
  info: '#2196f3',
  neutral: '#757575',
};

